<div class="page">
  <app-page-header itemName="{{ balance.get('number') }}" page-title="balances.detail.pageTitle"></app-page-header>
  <div class="page-content">
    <mat-card class="custom-card">
      <mat-card-title>{{ 'balances.detail.editTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>

          <app-creator-updator-box [data]="balance"></app-creator-updator-box>

          <div class="row h6 mt-4 text-muted font-weight-normal" *ngIf="balance">
            <div class="col-12">
              <mat-chip-list class="d-block py-2">
                <div *ngIf="balance.status === 'open'">
                  <mat-chip selected class="chip-green" matTooltip="{{ 'balances.status.tooltip' | translate }}">
                    {{ 'balances.status.open' | translate }}
                  </mat-chip>
                  <button mat-stroked-button matTooltip="{{ 'balances.status.moveToPendingTooltip' | translate }}"
                    (click)="onStatusChange()">
                    {{ 'balances.status.moveToPending' | translate }}
                  </button>
                </div>
                <div *ngIf="balance.status === 'pending'">
                  <mat-chip selected class="chip-yellow" matTooltip="{{ 'balances.status.tooltip' | translate }}">
                    {{ 'balances.status.pending' | translate }}
                  </mat-chip>
                  <button mat-stroked-button matTooltip="{{ 'balances.status.moveToClosedTooltip' | translate }}"
                    (click)="onStatusChange()">
                    {{ 'balances.status.moveToClosed' | translate }}
                  </button>
                </div>
                <div *ngIf="balance.status === 'closed'">
                  <mat-chip selected class="chip-red" matTooltip="{{ 'balances.status.tooltip' | translate }}">
                    {{ 'balances.status.closed' | translate }}
                  </mat-chip>
                  <button mat-stroked-button matTooltip="{{ 'common.cta.exportPdf' | translate }}"
                    (click)="onGeneratePdf()">
                    <app-card-spinner [visible]="!companyId" type="zero"></app-card-spinner>
                    <mat-icon fontSet="fal" fontIcon="fa-file-pdf" class="icon-action"></mat-icon>
                    {{ 'common.cta.exportPdf' | translate }}
                  </button>
                </div>
              </mat-chip-list>
            </div>
            <div class="col-12 col-sm-6 mt-3">
              <strong class="custom-label">{{ 'balances.fields.number' | translate }}: </strong>
              {{ balance.number }}
            </div>
            <div class="col-12 col-sm-6 mt-3">
              <strong class="custom-label">{{ 'balances.fields.property' | translate }}: </strong>
              
              <a routerLink="../../../properties/{{ balance.property?._id}}/home">
                {{ balance.property ? balance.property.name : '' }}
              </a>
            </div>
          </div>

          <!-- Invoices -->
          <div [hidden]="!showInvoice">
            <hr />
            <div class="mt-5">
              <strong>{{ 'invoices.title' | translate }}</strong>
            </div>
            <div class="mt-2 mb-4">
              <button class="add-icon-button mr-2" color="primary" (click)="onNewInvoice()" mat-flat-button
                matTooltip="{{ 'invoices.add.title' | translate }}" matTooltipPosition="above">
                {{ 'invoices.add.title' | translate }}
              </button>
            </div>
            <div class="table-wrapper">
              <div class="table-toolbar">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-6 col-md-6">
                    <!-- <mat-form-field>
                      <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                        class="reset-input-icon" *ngIf="input.value"></mat-icon>
                    </mat-form-field> -->
                  </div> <!-- /.col-12.col-md-4 -->
                  <div class="col-12 col-sm-6 col-md-6 text-right">
                    <button mat-button (click)="onInvoiceExport()" class="d-none d-sm-inline-block"
                      *ngIf="loggedUserPermissions.includes('canExportBalances')">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                      {{ 'common.words.export' | translate }}
                    </button>
                    <button mat-button (click)="onResetInvoicesFilters()" class="d-none d-sm-inline-block">
                      <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                      {{ 'common.cta.resetFilters' | translate }}
                    </button>
                  </div> <!-- /.col-12.col-md-8 -->
                </div> <!-- /.row -->
              </div> <!-- /.table-toolbar -->
              <div class="spinner-container" *ngIf="dataSource && dataSource.loading$ | async">
                <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
              </div> <!-- /.spinner-container -->
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="number"
                  matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                  <ng-container matColumnDef="index">
                    <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      {{ i + 1 }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                      {{ 'invoices.fields.number' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input type="text" matInput [formControl]="numberFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetInvoicesFilter(numberFilter)"
                          class="reset-input-icon" *ngIf="numberFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                      {{ 'invoices.fields.date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.date | dateFormat }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                          placeholder="{{ 'common.cta.select' | translate }}" [formControl]="dateFilter"
                          style="cursor: pointer" />
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetInvoicesFilter(dateFilter)"
                          class="reset-input-icon" *ngIf="dateFilter.value"></mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="file">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-40">
                      {{ 'invoices.fields.file' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div *ngFor="let file of element.file; let i = index">
                        <a href="{{ configService.apiHost }}/{{ file.path }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
                          {{ file.originalName }}
                        </a>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input type="text" matInput [formControl]="fileFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetInvoicesFilter(fileFilter)"
                          class="reset-input-icon" *ngIf="fileFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="text-right pr-5">
                      {{ 'common.cta.actions' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action pr-3"
                        matTooltip="{{ 'common.cta.open' | translate }}"
                        (click)="onEditInvoice(element)">
                      </mat-icon>
                      <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action pr-3"
                        matTooltip="{{ 'common.cta.delete' | translate }}"
                        (click)="onDeleteInvoice(element._id)">
                      </mat-icon>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                    [class.even-row]="(i % 2) == 0"></tr>
                  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                </table>
                <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                  showFirstLastButtons></mat-paginator>
              </div> <!-- /.table-responsive -->
            </div> <!-- /.table-wrapper -->
          </div>

          <div class="form-wrapper">
            <form [formGroup]="form">
              <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
            </form>
          </div> <!-- /.form-wrapper -->

          <div class="row h6 text-muted font-weight-normal" *ngIf="balance">
            <div class="col-9"></div>
            <div class="col-3">
              <strong>
                <div class="custom-label">{{ 'balances.fields.total' | translate }}: </div>
                {{ displayedTotal ? displayedTotal.toFixed(2) : '0' }} €
              </strong>
            </div>
          </div>
          <!-- <button class="ml-2" mat-stroked-button *ngIf="notes && notes.length" (click)="onViewDocumentNotes()">
            <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="primary"></mat-icon>
            {{ 'properties.structures.showNotes' | translate }}
          </button> -->
          <button class="ml-2" mat-stroked-button *ngIf="balanceDetailsView" (click)="onViewDetails()">
            <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="primary"></mat-icon>
            {{ 'balances.showDetail' | translate }}
          </button> 
          <button class="ml-2" mat-stroked-button *ngIf="balanceDetailsView" (click)="onPrintDetails()">
            <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="primary"></mat-icon>
            {{ 'balances.printDetail' | translate }}
          </button> 
          <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
            <formly-form [form]="form" [fields]="notesField" [model]="model" [options]="options"></formly-form>
            <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate mt-2">
            </mat-spinner-button>
          </form>
          
          <div class="note-content" *ngIf="notes && notes.length > 0">
            <div class="title">{{ 'properties.structures.notes' | translate}}</div>
            <table class="table table-borderless table-striped">
              <thead>
                <tr>
                  <th style="width: 3%;">#</th>
                  <th style="width: 15%;">{{ 'platformNotes.fields.category' | translate }}</th>
                  <th style="width: 15%;">{{ 'platformNotes.fields.title' | translate }}</th>
                  <th style="width: 15%;">{{ 'platformNotes.fields.description' | translate }}</th>
                  <th style="width: 15%;">{{ 'platformNotes.fields.createdAt' | translate }}</th>
                  <th style="width: 15%;">{{ 'platformNotes.fields.createdBy' | translate }}</th>
                  <th style="width: 15%;">{{ 'platformNotes.fields.file' | translate }}</th>
                  <th style="width: 7%;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of notes; let i = index">
                  <td style="width: 3%;">{{ i + 1 }}</td>
                  <td style="width: 15%;"><span *ngIf="item.category !== '' && item.category !== 'undefined'">{{ 'platformNotes.categories.' + item.category | translate }}</span></td>
                  <td style="width: 15%;">{{ item.title }}</td>
                  <td style="width: 15%;">{{ item.text }}</td>
                  <td style="width: 15%;">{{ item.createdAt | date:'medium' }}</td>
                  <td style="width: 15%;">{{ item.createdBy.firstName }} {{ item.createdBy.lastName }}</td>
                  <td style="width: 15%;">
                    <div *ngIf="item.file && item.file.path">
                      <a href="{{ configService.apiHost }}/{{ item.file.path }}" target="_blank" 
                        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        {{ item.file.originalName }}
                      </a>
                    </div>
                  </td>
                  <td style="width: 7%;">
                    <div class="row" *ngIf="!item.property">
                      <div class="col-6">
                        <mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action" matTooltip="{{ 'common.cta.modify' | translate}}"
                          (click)="onEdit(item?.text, item._id)">
                        </mat-icon>
                      </div>
                      <div class="col-6">
                        <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action" matTooltip="{{ 'common.cta.remove' | translate}}"
                          (click)="onDeleteNote(item._id)">
                        </mat-icon>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->